import { render, staticRenderFns } from "./snb.vue?vue&type=template&id=78aabbc6&scoped=true&"
import script from "./snb.vue?vue&type=script&lang=js&"
export * from "./snb.vue?vue&type=script&lang=js&"
import style0 from "./snb.vue?vue&type=style&index=0&id=78aabbc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aabbc6",
  null
  
)

export default component.exports